import { Pipe, PipeTransform } from '@angular/core';
import { TypeFormation } from '../../models/typeFormation';

@Pipe({
	name: 'filterTypeFormationByName'
})
export class FilterTypeFormationByNamePipe implements PipeTransform {
	transform(typeFormation: TypeFormation[], filter: string): TypeFormation[] {
		if (
			!typeFormation ||
			!filter ||
			typeFormation === null ||
			filter === null ||
			filter === ''
		) {
			return typeFormation;
		}

		return typeFormation.filter((typeFormation: TypeFormation) => {
			if (typeFormation.name) {
				// TODO: add lastName too
				return typeFormation.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
